import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    invoiceStatus: [],
    invoiceOpen: [],
    invoicePay: [],
    invoiceDispute: [],
    invoiceHistoric: []
  },
  mutations: {
    SET_INVOICE_STATUS(state, value) {
      state.invoiceStatus = value;
    },

    SET_INVOICE_OPEN(state, value) {
      state.invoiceOpen = value;
    },
    SET_INVOICE_PAID(state, value) {
      state.invoicePay = value;
    },
    SET_INVOICE_DISPUTE(state, value) {
      state.invoiceDispute = value;
    }
  },
  actions: {
    getInvoiceStatus(context, ref) {
      apiServices
        .getBillAggInvoice(ref)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit("SET_INVOICE_STATUS", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    getInvoiceFullStatus(context, payload) {
      const kube = {
        entityUUID: payload.ca,
        status: payload.status
      };
      apiServices
        .openInvoiceUnpaid(kube)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit(payload.mutation, obj.message);
            localStorage.setItem("iOpen", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    printInvoice(context, type) {
      apiServices
        .getPrintInvoice(type)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let payload = {
              color: "success",
              text: "A carregar factura...",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const d = new Date();
            let year =
              d.getFullYear() +
              "_" +
              d.getMonth() +
              "_" +
              d.getDay() +
              "_" +
              d.getSeconds();
            const nameInvoice = "invoice_kyami_pay_" + year;
            link.setAttribute("download", nameInvoice);
            document.body.appendChild(link);
            link.click();
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getInvoiceStatusInStore(state) {
      return state.invoiceStatus;
    },
    getInvoiceOpenInStore(state) {
      if (state.invoiceOpen.length === 0) return localStorage.getItem("iOpen");
      return state.invoiceOpen;
    },
    getInvoicePaidInStore(state) {
      if (state.invoicePay.length === 0) return localStorage.getItem("iOpen");
      return state.invoicePay;
    },
    getInvoiceDisputeInStore(state) {
      if (state.invoiceDispute.length === 0)
        return localStorage.getItem("iOpen");
      return state.invoiceDispute;
    },
    getInvoiceHistoric(state) {
      if (state.invoiceHistoric.length === 0)
        return localStorage.getItem("iOpen");
      return state.invoiceHistoric;
    }
  }
};
